import React, {useState, useMemo, MouseEvent} from 'react';
import cx from 'classnames';
import {Flex, Icon, PriorityIcon, Text} from '@priority-software/priority-style-react';
import {StatusDropdown} from './StatusDropdown';
import {getScrollAreaMaxHeight} from '../../utils';
import {isRTL} from '../../../../Localization';
import styles from '../../styles/ToDoListConent.module.scss';
import {getDropdownContentStyle} from '../../utils';
import {priority} from '@priority-software/priority-proto-api/lib';
import {Record} from '../../../../stores/Form/Record';
import {apiLocker} from '../../../../stores/Form';

type StatusFieldProps = {
    column: priority.netitems.form.IColumn;
    record: Record;
    getStatusList: (record: Record) => Promise<priority.netitems.form.ISelectValues[]>;
    saveUpdate: () => void;
    updateTaskStatus: (value: string) => void;
    setIsScrollbarDisabled: (value: boolean) => void;
};

type ContentStyle = {
    top?: number;
    bottom?: number;
    left?: number;
    right?: number;
};

export type DropdownProps = {
    formStatuses: priority.netitems.form.ISelectValues[];
    contentStyle: ContentStyle;
    scrollAreaMaxHeight: number;
};

const STATUS_FIELD = 'statusField';

export const StatusField = ({
    column,
    record,
    getStatusList,
    saveUpdate,
    updateTaskStatus,
    setIsScrollbarDisabled
}: StatusFieldProps) => {
    const [dropdownProps, setDropdownProps] = useState<DropdownProps>(null);
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const scrollAreaMaxHeight = useMemo(() => {
        return getScrollAreaMaxHeight(window.innerHeight);
    }, [window.innerHeight]);

    const handleOpenStatusList = async (e: MouseEvent<HTMLDivElement>) => {
        if (isOpen || apiLocker.isLock(record.parentForm.session)) {
            return;
        }
        const formStatuses = await getStatusList(record);
        if (!!formStatuses?.length) {
            let targetEl = e?.target as HTMLDivElement;
            if (targetEl.classList.contains(STATUS_FIELD)) {
                targetEl = targetEl.childNodes[0] as HTMLDivElement;
            } else {
                targetEl = targetEl.parentNode as HTMLDivElement;
            }
            const contentStyle = getDropdownContentStyle({
                fieldClientRect: targetEl.getBoundingClientRect(),
                scrollAreaMaxHeight,
                rtl: isRTL()
            });
            setIsScrollbarDisabled(true);
            setDropdownProps({formStatuses, contentStyle, scrollAreaMaxHeight});
            setIsOpen(true);
        }
    };

    return (
        <div
            className={cx(STATUS_FIELD, styles.mainColumn, styles.clickable, {
                [styles.disabled]: isOpen || column.Readonly
            })}
            onClick={handleOpenStatusList}
        >
            <Flex componentClasses={styles.statusFieldContent}>
                <Text
                    skin="paragraph-2"
                    textColor="primary-700"
                    componentClasses={styles.fieldTxtVal}
                >
                    {record.getField(column.ID as number)?.origValue?.toString()}
                </Text>
                {!column.Readonly && (
                    <Icon
                        icon={PriorityIcon.arrowDropDown}
                        componentClasses={cx(styles.statusMenuIcon, {
                            [styles.triggerOpen]: isOpen
                        })}
                    />
                )}
                {isOpen && (
                    <StatusDropdown
                        dropdownProps={dropdownProps}
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                        saveUpdate={saveUpdate}
                        updateTaskStatus={updateTaskStatus}
                        setIsScrollbarDisabled={setIsScrollbarDisabled}
                    />
                )}
            </Flex>
        </div>
    );
};
